import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    livePositionNotAvailable: translate({ id: 'rm.contextual.devices.livePositionNotAvailable' }),

    unknownPosition: translate({ id: 'rm.contextual.positionNA' }),

    devicesCounter: (count: number) =>
      translate({ id: 'global.counter.devices', values: { count } }),
  }))

  return api
}
